module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc4-9b336a41dd29ad6570c52b05f463706c.jpg";